module.exports = "<button class=\"btn btn-outline-primary\">\n      Notifications\n      <span class=\"badge badge-secondary\">4</span>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Badge/BadgeButton.html
// module id = 372
// module chunks = 0